export const icons = {
  dev: {
    logo: './img/logo.png',
    linkedin: './img/linkedin.png',
    instagram: './img/instagram.png',
    facebook: './img/facebook.png',
    banner: './img/banner.png',
  },
};
